import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from 'app/shared/contexts/user';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  const { user, isLoading } = useUser();

  if (user || isLoading) {
    return <Navigate to="/hello" />;
  }

  return <Navigate to="/error" />;
};
